const select = (editor) => {

    editor.BlockManager.add('select', {
        label: `
              <svg width='1.4vw' height = '1.4vw' viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path class="gjs-block-svg-path" d="M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z" fill-rule="nonzero"></path>
                  <polygon class="gjs-block-svg-path" transform="translate(18.500000, 12.000000) scale(1, -1) translate(-18.500000, -12.000000) " points="18.5 11 20 13 17 13"></polygon>
                  <rect class="gjs-block-svg-path" x="4" y="11.5" width="11" height="1"></rect>
              </svg>
              <div class='gjs-fontFamily gjs-fontFamily'>Select</div>
        `,
        category: 'Forms ',
        content: `  <select class="form-select" aria-label="Default select example">
                        <option dataitem=true selected>Open this select menu</option>
                        <option dataitem=true value="1">One</option>
                        <option dataitem=true value="2">Two</option>
                        <option dataitem=true value="3">Three</option>
                    </select>`,
        attributes: {},
    });

}

export default select;